document.querySelectorAll("[data-cart-line]").forEach((line) => {
  const input = line.querySelector("input[type=number]");
  line.querySelector("[data-qty-minus]")?.addEventListener("click", () => {
    input.value = Math.max(0, Number(input.value) - 1);
    input.form.requestSubmit();
  });
  line.querySelector("[data-qty-plus]")?.addEventListener("click", () => {
    input.value = Number(input.value) + 1;
    input.form.requestSubmit();
  });
});

// Geboortedatum direct opslaan, zodat hij ook bewaard blijft als iemand eerst iets verwijdert.
const birthday = document.querySelector("[data-cart-birthday]");
birthday?.addEventListener("change", () => {
  fetch(window.Shopify?.routes?.root ? Shopify.routes.root + "cart/update.js" : "/cart/update.js", {
    method: "POST",
    headers: { "Content-Type": "application/json", Accept: "application/json" },
    body: JSON.stringify({ attributes: { Geboortedatum: birthday.value } }),
  }).catch(() => {});
});
